import useSupportStore from "../../../store/supportStore";
import { formatDateT } from "../../../../../shared/utils/formatters";

const stepKey = "spVehicle";

const SpVehicleMapper = {
  get: () => {
    const store = useSupportStore.getState();
    return store[stepKey] || {};
  },
  set: (data) => {
    const store = useSupportStore.getState();
    store.updateStepFields(stepKey, data);

    const prevLookup = data.prevLookupVehicleReg || {};
    const prevManual = data.prevManualVehicleReg || {};
    const overnightAddress = data.lookUpAddress ?? {
      house: data.address ?? data.manualAddress,
      street: data.manualSecondAddress,
      city: data.city,
      county: data.county,
      postcode: data.postcode,
    };
    const details = {
      "What is your new vehicle registration?": data.prevVehicleRegis?.toUpperCase(),
      ...(prevLookup &&
        Object.keys(prevLookup).length > 0 && {
          "What is the make and model?": `${prevLookup.abiModel ||
            prevLookup.model ||
            ""} ${prevLookup.abiMake || prevLookup.make || ""}`.trim(),
          "What is the year of make?": prevLookup.abiVehicleInfoDesc
            ? prevLookup.abiVehicleInfoDesc.split(",")[0]
            : prevLookup.preVehicleSearch,
          "What is the engine size?": prevLookup.abiVehicleInfoDesc
            ? prevLookup.abiVehicleInfoDesc.split(",")[1]
            : prevLookup.preVehicleSearch,
          "How many seats does the vehicle have including the driver?": prevLookup.abiVehicleInfoDesc
            ? prevLookup.abiVehicleInfoDesc.split(",")[2]
            : prevLookup.preVehicleSearch,
        }),
      ...(prevManual &&
        Object.keys(prevManual).length > 0 && {
          "What is the make and model?": `${prevManual.abiMake ||
            ""} ${prevManual.abiModel || ""}`.trim(),
          "What is the engine size?": prevManual.abiVehicleInfoDesc
            ? prevManual.abiVehicleInfoDesc.split(",")[1]
            : undefined,
          "What is the year of make?": prevManual.abiVehicleInfoDesc
            ? prevManual.abiVehicleInfoDesc.split(",")[0]
            : undefined,
          "How many seats does the vehicle have including the driver?":
            data.prevVehicleDoor?.value,
        }),
      "Will your vehicle continue to be licenced by the existing licencing authority disclosed on your policy?":
        data.exitingLicenseAuth,
      ...(data.exitingLicenseAuth === "No" && {
        "What will be the licencing authority?": data.LicenseAuth?.label,
      }),
      "Will your vehicle be plated for Private hire or Public Hire/Hackney carriage?":
        data.hireType?.label,
      "What is your vehicle body type?": data.bodyType?.label,
      "Is your vehicle a Manual or Automatic?": data.transmissionType?.label,
      "When did you purchase the vehicle? Or when will you purchase the vehicle?":
        data.purchaseDate,
      "What is the value of the vehicle?": data.marketValue,
      "Who is the registered keeper of the vehicle?": data.keeper?.label,
      "Who is the registered owner of the vehicle?": data.owner?.label,
      "Where is your vehicle located overnight?": data.locOverNight?.label,
      "Is your vehicle kept at your home address overnight?":
        data.overNightHome,
      ...(data.overNightHome === "No" && {
        "Overnight address": overnightAddress,
        "What is the overnight postcode?":
          overnightAddress?.postcode?.toUpperCase(),
      }),
    };

    const currentChanges = store.Payload.Changes;
    store.updateField("Changes", {
      ...currentChanges,
      Vehicle: {
        Details: details,
        effectiveFrom: formatDateT(data.vehicleEffectiveDateTime) || "",
        Requested: true,
      },
    });
  },
};

export default SpVehicleMapper;
